import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { ButtonModule, IconsModule, ModalModule, TagModule } from '@fcom/ui-components';
import { UiTranslateModule } from '@fcom/ui-translate';
import { ComponentsModule } from '@fcom/common/components/components.module';
import { ImagesModule } from '@fcom/common/components/images/images.module';
import { DirectiveModule } from '@fcom/common/directives/directive.module';
import { GtmModule } from '@fcom/common/gtm/gtm.module';
import { PipesModule } from '@fcom/common/pipes/pipes.module';

import { ContentServicesModule } from '../services/content-services.module';
import { BlockOfferTileComponent } from './block-offer/block-offer-tile.component';

// Exports dummy content components as shared module for importing on child modules of cms module and other use cases

@NgModule({
  imports: [
    ButtonModule,
    CommonModule,
    ComponentsModule,
    DirectiveModule,
    GtmModule,
    ImagesModule,
    UiTranslateModule,
    PipesModule,
    IconsModule,
    ContentServicesModule,
    ModalModule,
    TagModule,
  ],
  declarations: [BlockOfferTileComponent],
  exports: [BlockOfferTileComponent],
})
export class ContentComponentsModule {}
